import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Space,
  Typography,
  message,
  Spin,
  Radio,
} from "antd";

import { useForm, useWatch } from "react-hook-form";
import { RcFile } from "antd/lib/upload/interface";
import {
  InputField,
  DateField,
  SelectField,
} from "../../../atoms/FormElement";

import axios from "../../../../utils/axiosInceptor";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { uploadDocumentMedia, getPresignedImage } from "../../../../utils/media";
import { adminService } from "../../../../configs/constants";
import { createAdvertisement } from "../service";

var _ = require("lodash");
const { Text } = Typography;

const { Paragraph } = Typography;

const UpdateAdvertisement = (props) => {



  const { singleAddData, action, onCancel, setAction, adCreatedFlag, setAdCreatedFlag,orgList,screenList } = props;

  const isDisable = action === 'View';


  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
 
  const [errorMessage, setErrorMessage] = useState("");
  const [advertisementStatus, setAdvertisementStatus] = useState('active');
  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [noticeDescription, setDescription] = useState(null);
  const { control, handleSubmit, formState: { errors }, reset, setValue, setError } = useForm();

 
  let keyValuePair = {
    startDate:'',
    endDate:'',
    title:'',
    subject:'',
    screens:[],
    audience:[],
    description:'Add description'
  }

  const setApiValuesToForm = (key, value) => {

    switch (key) {
      case 'startDate':
        {
         
          setStartDate(value);
          
        }
        break;
      case 'endDate':
        {
            setEndDate(value);
          
        }
        break;
      case 'audience':

         if(singleAddData?.audience?.length > 0){
          const outPut = _.map(singleAddData?.audience?.[0]?.data, (item, index) => {
            return {
              label: orgList.find(prop => prop.value === item)?.label,
              value: orgList.find(prop => prop.value === item)?.value
            }
          })
          
           if(outPut?.length > 0){
            setValue('organizations', outPut, { shouldValidate: true, });
            return;
           }
         }else{
          setValue('organizations', [], { shouldValidate: true, });
         }
  
       break; 
      case 'screens':
           
         let outPut = [];
         if(singleAddData?.screens?.length > 0){
          singleAddData?.screens?.forEach((item) => {
            outPut?.push({
             label: item,
             value: item
           })
            });
            setValue('screen', outPut, { shouldValidate: true, });
            return;
         }else{
          setValue('screen', outPut, { shouldValidate: true, });
         }
       
        break;
      case 'description':
        {
          setDescription(value);
          setValue('description', value, { shouldValidate: true, });
        }
        break;

      default:
        setValue(key, value);
        break;
    }
  }

  useEffect(() => {
    if (singleAddData) {
      Object.entries(singleAddData).forEach(([key, value]) => {
        setApiValuesToForm(key, value);
      })
    }else{
      Object.entries(keyValuePair).forEach(([key, value]) => {
        setApiValuesToForm(key, value);
      })
    }
   
  }, [action,singleAddData]);

  const description: any = useWatch({ control, name: "description" });

  const onFinish = async (values) => {

    if (!endDate) {
      setError('endDate', { type: 'manual', message: 'Please select end date' })
      return;
    }

    if (!startDate) {
      setError('startDate', { type: 'manual', message: 'Please select the start date' })
      return;
    }

    if (!values.description) {
      message.error("please enter the description!")
      return;
    }

    if (values?.screen?.length === 0) {
      setError('screen', { type: 'manual', message: 'Please select the screen name' })
      return;
    }

    if (values?.organizations?.length === 0) {
      setError('organizations', { type: 'manual', message: 'Please select the organizations' })
      return;
    }


    try {

      
      let organizations = values?.organizations?.map((item) => item?.value);
      let screens = values?.screen?.map((item) => item?.value);

      let data = {
        "title": values?.title,
        "subject": values?.subject,
        "description": values?.description,
        "audience": {
          "data": organizations,
        },
        "status": values?.adStatus ? values?.adStatus : advertisementStatus,
        "startDate": startDate,
        "endDate": endDate,
        "type": "Advertisement",
        "screens": screens
      }
      let response = null;
      action === 'Edit'
        ?
        response = await createAdvertisement(data, singleAddData?.noticeId)
        :
        response = await createAdvertisement(data);

      if (response?.data?.code === 200) {

        message?.success('Advertisement created successfully.');
        setAdCreatedFlag(!adCreatedFlag)
        setAction(null);
        onCancel();

        reset();

      }
    } catch (e) {
      const { response } = e;
      response?.data?.error && message.error(response?.data?.error);
      console.log(e, 'Advertisement');
    }

  };

  const getUrl = async (data) => {
    return await getPresignedImage([data]);
  };

  function uploadAdapter(loader) {

    let isSigned = false;

    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file.then(async (file) => {
            try {
              const { data } = await uploadDocumentMedia({ file_asset: file as RcFile }, isSigned);
              const documentId = data?.result?.documentId;
              const finalImg = await getUrl(documentId);
              resolve({ default: finalImg[0] });
            } catch (error) {
              reject(error)
            }
          })
        })
      }
    }
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    }
  }

  const checkValidDate = (current)=>{
   
    const maxDate = endDate && dayjs(endDate);
    return current && current.isAfter(maxDate, 'day');
  }

  const checkValidDateForEndDate = (current)=>{

    const minDate = startDate && dayjs(startDate);
    return current && current.isBefore(minDate, 'day');
  }

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)} className={action === 'View' ? "disabled-look" : ""}>
        {loader && !isError && (
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Space size={24} className="w-100 text-center" direction="vertical">
                <Spin size="large" className="ag-fontSize32" />
              </Space>
            </Col>
          </Row>
        )}
        {!submited ? (
          <>
            <Row gutter={24}>

              <Col span={24}>
                <InputField
                  isRequired={true}
                  fieldname="title"
                  label="Title"
                  disabled={isDisable}
                  control={control}
                  iProps={{ placeholder: "Enter Title" }}
                  initValue=""
                  validate={errors.title && "error"}
                  validMessage={errors.title && errors.title.message}
                  rules={{
                    required: "Please enter title",
                  }}
                />
              </Col>

              <Col span={24}>
                <InputField
                  isRequired={true}
                  fieldname="subject"
                  label="Subject"
                  disabled={isDisable}
                  control={control}
                  iProps={{
                    placeholder: "Enter Subject",

                  }}
                  initValue=""
                  validate={errors.subject && "error"}
                  validMessage={errors.title && errors.subject.message}
                  rules={{
                    required: "Please enter Subject",
                  }}
                />
              </Col>

              <Col span={24}>

                <CKEditor
                  editor={ClassicEditor}
                  disabled={isDisable}
                  data={description || noticeDescription || "<p>Add description</p>"}
                  config={{
                    extraPlugins: [uploadPlugin]
                  }}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setValue('description', data)
                  }}
                  onBlur={(event, editor) => {
                    // console.log( 'Blur.', editor );
                  }}
                  onFocus={(event, editor) => {
                    // console.log( 'Focus.', editor );
                  }}
                />
              </Col>


            </Row>

            <Row style={{ marginTop: '15px' }}>

              <Col span={24}>
                <SelectField
                  fieldname="screen"
                  label="Screen"
                  isRequired={true}
                  control={control}
                  setValue={setValue}
                  disabled={isDisable}
                  iProps={{ placeholder: "Select screen", isDisabled: false, isMulti: true }}
                  selectOption={screenList}
                  validate={errors.screen && "error"}
                  validMessage={errors.screen && errors.screen.message}
                />
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <SelectField
                  fieldname="organizations"
                  label="Organizations"
                  isRequired={true}
                  control={control}
                  disabled={isDisable}
                  setValue={setValue}
                  iProps={{ placeholder: "Select Organizations", isDisabled: false, isMulti: true }}
                  selectOption={orgList}
                  validate={errors.organizations && "error"}
                  validMessage={errors.organizations && errors.organizations.message}
                />
              </Col>
            </Row>

            <Row gutter={24} >
              <Col span={12}>
                <DateField
                  fieldname="startDate"
                  label="Start Date"
                  isRequired={true}
                  control={control}
                  disabledDate={checkValidDate}
                  iProps={{
                    placeholder: "YYYY-MM-DD",
                    format: "YYYY-MM-DD",
                    disabled: false,
                    value: startDate ? dayjs(startDate) : "",
                    onChange: (dateString) => {
                      const abc = dateString && dayjs(dateString).format("YYYY-MM-DD");
                      setStartDate(abc);
                      setValue("startDate", abc);
                    },
                  }}
                  rules={{
                    setValueAs: (value) => moment(value, "YYYY-MM-DD"),
                  }}
                  validate={errors.startDate && "error"}
                  validMessage={errors.startDate && errors.startDate.message}
                />
              </Col>
              
              <Col span={12}>
                <DateField
                  fieldname="endDate"
                  label="End Date"
                  isRequired={true}
                  control={control}
                  disabledDate={checkValidDateForEndDate}
                  iProps={{
                    placeholder: "YYYY-MM-DD",
                    format: "YYYY-MM-DD",
                    disabled: false,
                    value: endDate ? dayjs(endDate) : "",
                    onChange: (timeChange, dateString) => {
                      const abc = dateString && dayjs(dateString).format("YYYY-MM-DD")
                      setEndDate(abc)
                      setValue("endDate", abc)
                    },
                  }}
                  rules={{
                    setValueAs: (value) => moment(value, "YYYY-MM-DD"),
                  }}
                  validate={errors.endDate && "error"}
                  validMessage={errors.endDate && errors.endDate.message}
                />
              </Col>

              <Col span={24} style={{ marginTop: 10 }}>
                <Text style={{ marginRight: '10px' }}>Select Status</Text>
                <Radio.Group
                  defaultValue="active"
                  disabled={false}
                  value={advertisementStatus}
                  onChange={(e) => {
                    setAdvertisementStatus(e.target.value)
                    setValue("adStatus", e.target.value)
                  }
                  }
                >
                  <Space size={4}>
                    <Radio value="active" className="Bo-radio">Active</Radio>
                    <Radio value="inactive" className="Bo-radio">In-Active</Radio>
                  </Space>
                </Radio.Group>
              </Col>
            </Row>
            {
             
           
              <Row gutter={24} style={{ marginTop: 20 }}>
               { action !== 'View' &&
                <Col>
                  <Button className="ag-green-button" htmlType="submit">
                   {action ? 'Update' : 'Create'}  
                  </Button>
                </Col>}
              </Row>
            }

          </>
        ) : (
          isError && (
            <>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Space
                    size={24}
                    className="w-100 text-center"
                    direction="vertical"
                  >
                    <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                    <Paragraph className="ag-error fontWeight600 mb-0">
                      {errorMessage}
                    </Paragraph>
                  </Space>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Button
                    className="ag-gray-button-outline"
                    htmlType="button"
                    onClick={() => {
                      setSubmited(false);
                      setisError(false);
                    }}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </>
          )
        )}
      </Form>
    </>
  );
};

export default UpdateAdvertisement;


